// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"a4ce9","button":"_4c713","button-overide":"d473c","buttonOveride":"d473c"};